import React, { Component } from "react";
import { connect } from "react-redux";
import {
    PageHeader,
    Row,
    Col,
    Select,
    Switch,
    Tag,
    Spin,
    message,
    Modal,
    Input,
    InputNumber,
    DatePicker,
    Alert,
    Steps,
    Dropdown,
    Menu,
    Button,
    Upload,
    Table,
    Statistic,
    Form as FormAntd,
} from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined, SaveOutlined, PlusOutlined, DeleteOutlined, MoreOutlined, StopOutlined, UndoOutlined, SyncOutlined, UploadOutlined, ThunderboltOutlined } from "@ant-design/icons";
import moment from "moment";
import { FormItem, InputItem, SelectItem, TextAreaItem, DynamicCardForm, ButtonItem, ErrorItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import SelectDocumentoItem from "../../../../Components/SelectDocumentoItem";
import { cmmsPost, ESQUEMAS_COBRO, normFile, fileListAPayload, cargarSucursales, generarVueltas, nombreVuelta, fechaDiaPayload, momentFechaDia, formatoMoneda, formatoPorcentaje, formatoFecha } from "../cmmsComun";
import { cargarListasCMMS } from "../componentes/accionesPlanes";
import EquiposContrato from "./EquiposContrato";
import CalendarizacionContrato from "./CalendarizacionContrato";
import ProgresoContrato from "./ProgresoContrato";
import "../cmms.css";

const { Option } = Select;
const { RangePicker } = DatePicker;

// Contrato de mantenimiento por pasos. General y Vueltas se guardan con "Guardar"; Equipos,
// Calendarizacion y Progreso trabajan directo sobre el contrato ya guardado.
// Se abre con history.push("/panel/cmmsContrato", { id, paso }) o { } para uno nuevo.

const PASOS = [
    { titulo: "General", descripcion: "Cliente, vigencia y cobro" },
    { titulo: "Vueltas", descripcion: "Periodos de atención" },
    { titulo: "Equipos", descripcion: "Qué equipos cubre", requiereGuardado: true },
    { titulo: "Calendarización", descripcion: "Fechas e ingenieros", requiereGuardado: true },
    { titulo: "Progreso", descripcion: "Programado vs realizado", requiereGuardado: true },
    { titulo: "Facturación", descripcion: "Ventas y cobranza" },
];

const PASO_DE_CAMPO = { clienteId: 0, fechas: 0, idContrato: 0, tipoContrato: 0 };

class Contrato extends Component {
    formRef = React.createRef();

    state = {
        loading: true,
        contrato: null,
        paso: this.props.location?.state?.paso || 0,
        vueltas: [],
        ventas: [],
        sucursales: [],
        clienteId: null,
        valorVariable: false,
        esquemaCobro: 1,
        tiposContrato: [],
        motivos: [],
        cancelar: null,
        nVueltas: 2,
        recarga: 0,
    };

    get id() {
        return this.state.contrato?._id || this.props.location?.state?.id || null;
    }

    componentDidMount() {
        this.cargar();
    }

    // Misma ruta con otro contrato (renovación / "renovado en"): React Router no vuelve a
    // montar la pantalla, así que se carga aquí.
    componentDidUpdate(prev) {
        const id = this.props.location?.state?.id;
        if (id && id !== prev.location?.state?.id && id !== this.state.contrato?._id) {
            this.setState({ contrato: null, paso: this.props.location?.state?.paso || 0, vueltas: [], ventas: [] }, async () => {
                this.formRef.current?.resetFields();
                this.setState({ loading: true });
                try {
                    await this.consultar(id);
                } finally {
                    this.setState({ loading: false });
                }
            });
        }
    }

    cargar = async () => {
        this.setState({ loading: true });
        try {
            const listas = await cargarListasCMMS(this.props);
            this.setState({ tiposContrato: listas.tiposContrato || [], motivos: listas.motivosNoRealizado || [] });
            if (this.props.location?.state?.id) await this.consultar(this.props.location.state.id);
            else this.formRef.current?.setFieldsValue({ diasAlertaRenovacion: 30, esquemaCobro: 1, fisico: false, refaccionesIncluidas: false, valorVariable: false });
        } finally {
            this.setState({ loading: false });
        }
    };

    consultar = async (id = this.id) => {
        const res = await cmmsPost(this.props, "datosContratoCMMS", { id });
        if (res.data.success !== 2) return message.error(res.data.message || "No se encontró el contrato");
        const c = res.data.contrato;
        this.formRef.current?.setFieldsValue({
            clienteId: c.clienteId,
            idContrato: c.idContrato,
            tipoContrato: c.tipoContrato || undefined,
            fechas: [momentFechaDia(moment, c.fechaInicio), momentFechaDia(moment, c.fechaConclusion)],
            diasAlertaRenovacion: c.diasAlertaRenovacion ?? 30,
            fisico: !!c.fisico,
            sucursalesIds: c.sucursalesIds || [],
            valorVariable: !!c.valorVariable,
            valor: c.valor,
            esquemaCobro: c.esquemaCobro || 1,
            cobroMensual: c.cobroMensual,
            refaccionesIncluidas: !!c.refaccionesIncluidas,
            numeroContrato: c.numeroContrato,
            leyendaEncabezado: c.leyendaEncabezado,
            responsableClienteDefault: c.responsableClienteDefault,
            contactos: c.contactos || [],
            archivos: c.archivos || [],
            notas: c.notas,
        });
        this.setState({
            contrato: c,
            clienteId: c.clienteId,
            valorVariable: !!c.valorVariable,
            esquemaCobro: c.esquemaCobro || 1,
            vueltas: (c.vueltas || []).map((v) => ({ _id: v._id, nombre: v.nombre, fechas: [momentFechaDia(moment, v.fechaInicio), momentFechaDia(moment, v.fechaFin)] })),
            ventas: c.ventas || [],
            sucursales: await cargarSucursales(this.props, c.clienteId),
        });
    };

    cambiarCliente = async (clienteId) => {
        this.formRef.current?.setFieldsValue({ sucursalesIds: [] });
        this.setState({ clienteId: clienteId || null, sucursales: await cargarSucursales(this.props, clienteId) });
    };

    // ─── Guardar ─────────────────────────────────────────────────────────────

    onFinish = async (values) => {
        const anteriores = this.state.contrato?.vueltas || [];
        const quitadas = anteriores.filter((v) => !this.state.vueltas.some((n) => n._id === v._id));
        if (quitadas.length && this.state.contrato?.planes) {
            const seguir = await new Promise((resolve) =>
                Modal.confirm({
                    title: "¿Quitar vueltas?",
                    content: `Se quitará ${quitadas.map((v) => `"${v.nombre}"`).join(", ")} y lo que tenía pendiente en el programa. Si ya hay servicios realizados en ella no se podrá quitar.`,
                    okText: "Quitar y guardar",
                    cancelText: "Regresar",
                    onOk: () => resolve(true),
                    onCancel: () => resolve(false),
                })
            );
            if (!seguir) return;
        }
        this.setState({ loading: true });
        try {
            const payload = {
                id: this.id,
                clienteId: values.clienteId,
                idContrato: values.idContrato,
                tipoContrato: values.tipoContrato,
                fechaInicio: fechaDiaPayload(values.fechas?.[0]),
                fechaConclusion: fechaDiaPayload(values.fechas?.[1]),
                diasAlertaRenovacion: values.diasAlertaRenovacion,
                fisico: !!values.fisico,
                sucursalesIds: values.sucursalesIds || [],
                valorVariable: !!values.valorVariable,
                valor: values.valor,
                esquemaCobro: values.esquemaCobro,
                cobroMensual: values.cobroMensual,
                refaccionesIncluidas: !!values.refaccionesIncluidas,
                numeroContrato: values.numeroContrato,
                leyendaEncabezado: values.leyendaEncabezado,
                responsableClienteDefault: values.responsableClienteDefault,
                contactos: values.contactos || [],
                notas: values.notas,
                archivos: await fileListAPayload(values.archivos),
                vueltas: this.state.vueltas.map((v) => ({ _id: v._id, nombre: (v.nombre || "").trim(), fechaInicio: fechaDiaPayload(v.fechas?.[0]), fechaFin: fechaDiaPayload(v.fechas?.[1]) })),
                ventas: this.state.ventas.map((v) => ({ ventaId: v.ventaId, texto: v.texto, periodo: v.periodo })),
            };
            const nuevo = !this.state.contrato;
            const res = await cmmsPost(this.props, nuevo ? "agregarContratoCMMS" : "editarContratoCMMS", payload);
            if (res.data.success !== 2) return message.error(res.data.message || "No se pudo guardar el contrato");
            const id = nuevo ? res.data.codigo : this.id;
            message.success(nuevo ? `Contrato ${res.data.folio} registrado. ${this.state.vueltas.length ? "Ahora agregue sus equipos." : "Ahora defina sus vueltas."}` : "Contrato guardado");
            const vueltasNuevas = this.state.vueltas.filter((v) => !v._id).map((v) => v.nombre);
            await this.consultar(id);
            if (nuevo) {
                // Sin vueltas todavia no se pueden programar equipos: primero las vueltas.
                const paso = this.state.vueltas.length ? 2 : 1;
                this.props.history.replace("/panel/cmmsContrato", { id, paso });
                this.setState({ paso });
            }
            if (!nuevo && vueltasNuevas.length && this.state.contrato?.equipos) this.ofrecerIncluirEnVueltas(vueltasNuevas);
            this.setState((s) => ({ recarga: s.recarga + 1 }));
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar el contrato");
        } finally {
            this.setState({ loading: false });
        }
    };

    // Vuelta nueva en un contrato con equipos: se ofrece incluirlos a todos.
    ofrecerIncluirEnVueltas = (nombres) => {
        const vueltas = (this.state.contrato?.vueltas || []).filter((v) => nombres.includes(v.nombre));
        if (!vueltas.length) return;
        Modal.confirm({
            title: "¿Incluir los equipos en la vuelta nueva?",
            content: `El contrato tiene ${this.state.contrato.equipos} equipos. ¿Les agrego su servicio en ${vueltas.map((v) => v.nombre).join(" y ")}? (Después puede quitar a los que no les toque.)`,
            okText: "Sí, incluir a todos",
            cancelText: "No",
            onOk: async () => {
                const r = await cmmsPost(this.props, "equiposContratoCMMS", { contratoId: this.id });
                const ids = (r.data.equipos || []).filter((e) => e.estado === 1).map((e) => e._id);
                for (const v of vueltas) await cmmsPost(this.props, "alternarVueltaContratoCMMS", { contratoId: this.id, activosIds: ids, vueltaId: v._id, incluir: true });
                message.success("Equipos incluidos");
                this.setState((s) => ({ recarga: s.recarga + 1 }));
                this.consultar();
            },
        });
    };

    onFinishFailed = (e) => {
        const campo = e?.errorFields?.[0]?.name?.[0];
        if (campo in PASO_DE_CAMPO) this.setState({ paso: PASO_DE_CAMPO[campo] });
        ErrorItem(e);
    };

    cancelarContrato = async () => {
        const motivo = (this.state.cancelar || "").trim();
        if (!motivo) return message.error("Escriba el motivo");
        const res = await cmmsPost(this.props, "cancelarContratoCMMS", { id: this.id, motivo });
        if (res.data.success !== 2) return message.error(res.data.message || "No se pudo cancelar");
        message.success("Contrato cancelado");
        this.setState((s) => ({ cancelar: null, recarga: s.recarga + 1 }));
        this.consultar();
    };

    reactivar = async () => {
        const res = await cmmsPost(this.props, "reactivarContratoCMMS", { id: this.id });
        if (res.data.success !== 2) return message.error(res.data.message || "No se pudo reactivar");
        message.success("Contrato reactivado");
        this.setState((s) => ({ recarga: s.recarga + 1 }));
        this.consultar();
    };

    renovar = () => {
        const c = this.state.contrato;
        Modal.confirm({
            title: "Renovar contrato",
            content: `Se crea un contrato nuevo que empieza el ${formatoFecha(moment(String(c.fechaConclusion).slice(0, 10)).add(1, "day"))} con los mismos datos, las mismas vueltas (un periodo después) y los mismos ${c.equipos} equipos, sin fechas todavía. Este contrato conserva su historia.`,
            okText: "Renovar",
            cancelText: "Cancelar",
            onOk: async () => {
                const res = await cmmsPost(this.props, "renovarContratoCMMS", { id: this.id });
                if (res.data.success !== 2) return message.error(res.data.message || "No se pudo renovar");
                message.success(`Contrato ${res.data.folio} creado con ${res.data.equipos} equipos. Revise su ID de contrato y fechas.`);
                // componentDidUpdate carga el contrato nuevo.
                this.props.history.push("/panel/cmmsContrato", { id: res.data.codigo, paso: 0 });
            },
        });
    };

    // ─── Pasos ───────────────────────────────────────────────────────────────

    ir = (paso) => {
        if (PASOS[paso].requiereGuardado && !this.state.contrato) return message.info("Guarde el contrato primero");
        this.setState({ paso }, () => window.scrollTo({ top: 0, behavior: "smooth" }));
    };

    renderPasos() {
        const c = this.state.contrato;
        return (
            <div className="cmms-pasos">
                <Steps type="navigation" size="small" current={this.state.paso} onChange={this.ir}>
                    {PASOS.map((p, i) => (
                        <Steps.Step
                            key={p.titulo}
                            title={p.titulo}
                            disabled={p.requiereGuardado && !c}
                            description={i === 1 ? `${this.state.vueltas.length} vuelta(s)` : i === 2 && c ? `${c.equipos} equipo(s)` : p.descripcion}
                        />
                    ))}
                </Steps>
            </div>
        );
    }

    renderNavegacion() {
        const { paso } = this.state;
        const ultimo = PASOS.length - 1;
        const siguiente = PASOS.findIndex((p, i) => i > paso && (!p.requiereGuardado || this.state.contrato));
        return (
            <div className="cmms-pasos-nav">
                <Button icon={<ArrowLeftOutlined />} disabled={paso === 0} onClick={() => this.ir(paso - 1)}>
                    Anterior
                </Button>
                <span style={{ color: "#7a8794", fontSize: 12 }}>
                    Paso {paso + 1} de {ultimo + 1}
                </span>
                {siguiente > 0 ? (
                    <Button type="primary" onClick={() => this.ir(siguiente)}>
                        Siguiente: {PASOS[siguiente].titulo} <ArrowRightOutlined />
                    </Button>
                ) : (
                    <span style={{ width: 90 }} />
                )}
            </div>
        );
    }

    renderGeneral(bloqueado) {
        return (
            <Row gutter={14}>
                <DynamicCardForm title="Datos generales" xs={24} lg={14}>
                    <Row gutter={12}>
                        <Col xs={24}>
                            <FormItem label="Cliente" name="clienteId" rules={[{ required: true, message: "Elija el cliente" }]}>
                                <SelectClientesItem
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                    width="100%"
                                    disabled={bloqueado || !!this.state.contrato?.equipos}
                                    onChange={this.cambiarCliente}
                                />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem label="ID de contrato" name="idContrato" tooltip="Como lo identifican ustedes (ej. MPC-RVD/003-26). El folio interno (CON…) se asigna solo.">
                                <InputItem placeholder="Ej. MPC-RVD/003-26" disabled={bloqueado} />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem label="Tipo de contrato" name="tipoContrato" tooltip="Las opciones se editan en Configuración.">
                                <SelectItem placeholder="Tipo de contrato" allowClear disabled={bloqueado}>
                                    {this.state.tiposContrato.map((t) => (
                                        <Option key={t} value={t}>
                                            {t}
                                        </Option>
                                    ))}
                                </SelectItem>
                            </FormItem>
                        </Col>
                        <Col xs={24} md={14}>
                            <FormItem label="Vigencia (inicio y término)" name="fechas" rules={[{ required: true, message: "Faltan las fechas del contrato" }]}>
                                <RangePicker format="DD/MM/YYYY" style={{ width: "100%" }} disabled={bloqueado} />
                            </FormItem>
                        </Col>
                        <Col xs={12} md={5}>
                            <FormItem label="Avisar (días antes)" name="diasAlertaRenovacion" tooltip="Días antes del término en que el contrato pasa a 'Por renovar'.">
                                <InputNumber min={0} max={365} style={{ width: "100%" }} disabled={bloqueado} />
                            </FormItem>
                        </Col>
                        <Col xs={12} md={5}>
                            <FormItem label="¿Contrato físico?" name="fisico" valuePropName="checked">
                                <Switch checkedChildren="Sí" unCheckedChildren="No" disabled={bloqueado} />
                            </FormItem>
                        </Col>
                        <Col xs={24}>
                            <FormItem label="Sucursales / unidades que cubre" name="sucursalesIds" tooltip="Vacío = todas las del cliente.">
                                <Select mode="multiple" allowClear placeholder={this.state.clienteId ? "Todas" : "Elija primero el cliente"} disabled={bloqueado || !this.state.clienteId} optionFilterProp="children" maxTagCount="responsive">
                                    {this.state.sucursales.map((s) => (
                                        <Option key={s._id} value={s._id}>
                                            {s.nombre}
                                        </Option>
                                    ))}
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </DynamicCardForm>
                <DynamicCardForm title="Cobro" xs={24} lg={10}>
                    <Row gutter={12}>
                        <Col xs={14}>
                            <FormItem label="Valor del contrato" name="valor">
                                <InputNumber min={0} style={{ width: "100%" }} disabled={bloqueado || this.state.valorVariable} formatter={(v) => (v ? `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")} parser={(v) => v.replace(/\$\s?|(,*)/g, "")} />
                            </FormItem>
                        </Col>
                        <Col xs={10}>
                            <FormItem label="Valor variable" name="valorVariable" valuePropName="checked">
                                <Switch disabled={bloqueado} onChange={(valorVariable) => this.setState({ valorVariable })} />
                            </FormItem>
                        </Col>
                        <Col xs={24}>
                            <FormItem label="Esquema de cobro" name="esquemaCobro">
                                <SelectItem disabled={bloqueado} onChange={(esquemaCobro) => this.setState({ esquemaCobro })}>
                                    {ESQUEMAS_COBRO.map((e) => (
                                        <Option key={e.value} value={e.value}>
                                            {e.label}
                                        </Option>
                                    ))}
                                </SelectItem>
                            </FormItem>
                        </Col>
                        <Col xs={14}>
                            <FormItem label="Cobro mensual" name="cobroMensual">
                                <InputNumber min={0} style={{ width: "100%" }} disabled={bloqueado || this.state.esquemaCobro === 3} formatter={(v) => (v ? `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")} parser={(v) => v.replace(/\$\s?|(,*)/g, "")} />
                            </FormItem>
                        </Col>
                        <Col xs={10}>
                            <FormItem label="Incluye refacciones" name="refaccionesIncluidas" valuePropName="checked">
                                <Switch checkedChildren="Sí" unCheckedChildren="No" disabled={bloqueado} />
                            </FormItem>
                        </Col>
                    </Row>
                </DynamicCardForm>
                <DynamicCardForm title="Orden de Servicio" xs={24} lg={14}>
                    <div className="cmms-ayuda">Lo que se imprime en las Órdenes de Servicio de este contrato (variante de licitación, como las de TINC / MEDIZIN).</div>
                    <Row gutter={12}>
                        <Col xs={24} md={10}>
                            <FormItem label="Número de contrato impreso" name="numeroContrato" tooltip="Si se deja vacío se imprime el ID de contrato.">
                                <InputItem placeholder="Ej. CLP029-027-2026" disabled={bloqueado} />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={14}>
                            <FormItem label="Responsable del cliente por defecto" name="responsableClienteDefault" tooltip="Se precarga en cada servicio del contrato.">
                                <InputItem placeholder="Ej. Ing. Orión Ángeles Torres" disabled={bloqueado} />
                            </FormItem>
                        </Col>
                        <Col xs={24}>
                            <FormItem label="Leyenda de la licitación" name="leyendaEncabezado">
                                <TextAreaItem rows={2} placeholder="Ej. Licitación Pública Nacional LPN/ISSEMYM/026/2026 - Servicio de mantenimiento preventivo y correctivo..." disabled={bloqueado} />
                            </FormItem>
                        </Col>
                    </Row>
                </DynamicCardForm>
                <DynamicCardForm title="Contactos del cliente" xs={24} lg={10}>
                    <FormAntd.List name="contactos">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map((field) => (
                                    <div key={field.key} className="cmms-contacto">
                                        <FormItem name={[field.name, "nombre"]} noStyle>
                                            <Input placeholder="Nombre" disabled={bloqueado} />
                                        </FormItem>
                                        <FormItem name={[field.name, "puesto"]} noStyle>
                                            <Input placeholder="Puesto" disabled={bloqueado} />
                                        </FormItem>
                                        <FormItem name={[field.name, "telefono"]} noStyle>
                                            <Input placeholder="Teléfono" disabled={bloqueado} />
                                        </FormItem>
                                        <FormItem name={[field.name, "correo"]} noStyle>
                                            <Input placeholder="Correo" disabled={bloqueado} />
                                        </FormItem>
                                        {!bloqueado && <Button type="text" danger icon={<DeleteOutlined />} onClick={() => remove(field.name)} />}
                                    </div>
                                ))}
                                {!bloqueado && (
                                    <ButtonItem type="dashed" htmlType="button" icon={<PlusOutlined />} onClick={() => add({ nombre: "", puesto: "", telefono: "", correo: "" })}>
                                        Agregar contacto
                                    </ButtonItem>
                                )}
                            </>
                        )}
                    </FormAntd.List>
                </DynamicCardForm>
                <DynamicCardForm title="Contrato escaneado y anexos" xs={24} lg={12}>
                    <FormItem name="archivos" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                        <Upload multiple beforeUpload={() => false} disabled={bloqueado}>
                            <ButtonItem type="default" htmlType="button" icon={<UploadOutlined />} disabled={bloqueado}>
                                Agregar archivos
                            </ButtonItem>
                        </Upload>
                    </FormItem>
                </DynamicCardForm>
                <DynamicCardForm title="Notas" xs={24} lg={12}>
                    <FormItem name="notas" noStyle>
                        <TextAreaItem rows={3} placeholder="Opcional" disabled={bloqueado} />
                    </FormItem>
                </DynamicCardForm>
            </Row>
        );
    }

    renderVueltas(bloqueado) {
        const fechas = this.formRef.current?.getFieldValue("fechas");
        const setVuelta = (i, cambios) => this.setState((s) => ({ vueltas: s.vueltas.map((v, j) => (j === i ? { ...v, ...cambios } : v)) }));
        return (
            <Row gutter={14}>
                <DynamicCardForm
                    title="Vueltas del contrato"
                    xs={24}
                    headerRight={
                        !bloqueado ? (
                            <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
                                <span style={{ fontSize: 12, color: "#7a8794" }}>Dividir la vigencia en</span>
                                <InputNumber size="small" min={1} max={12} value={this.state.nVueltas} onChange={(nVueltas) => this.setState({ nVueltas })} style={{ width: 60 }} />
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    htmlType="button"
                                    icon={<ThunderboltOutlined />}
                                    disabled={!fechas?.[0] || !fechas?.[1]}
                                    onClick={() => {
                                        const generadas = generarVueltas(moment, fechas[0], fechas[1], this.state.nVueltas);
                                        const conservar = (i) => this.state.vueltas[i]?._id;
                                        this.setState({ vueltas: generadas.map((g, i) => ({ _id: conservar(i), nombre: this.state.vueltas[i]?.nombre || g.nombre, fechas: [g.fechaInicio, g.fechaFin] })) });
                                    }}
                                >
                                    vueltas iguales
                                </ButtonItem>
                            </span>
                        ) : null
                    }
                >
                    <div className="cmms-ayuda">
                        Periodos en que se atiende a los equipos (ej. ISSEMYM: 1ra Vuelta marzo–mayo, 2da Vuelta septiembre–noviembre). A cada equipo se le programa un servicio en cada vuelta que le toque; un equipo de un solo
                        servicio al año va en una sola. No se pueden encimar.
                    </div>
                    {!this.state.vueltas.length && <Alert type="info" showIcon message="El contrato todavía no tiene vueltas. Agregue al menos una para poder programar sus equipos." style={{ marginBottom: 10 }} />}
                    {this.state.vueltas.map((v, i) => (
                        <div key={v._id || `n${i}`} className="cmms-vuelta">
                            <span className="cmms-vuelta-num">{i + 1}</span>
                            <Input value={v.nombre} placeholder="Nombre" maxLength={60} disabled={bloqueado} onChange={(e) => setVuelta(i, { nombre: e.target.value })} style={{ width: 220 }} />
                            <RangePicker
                                format="DD/MM/YYYY"
                                value={v.fechas}
                                disabled={bloqueado}
                                onChange={(f) => setVuelta(i, { fechas: f || [] })}
                                disabledDate={fechas?.[0] && fechas?.[1] ? (d) => d && (d.isBefore(fechas[0].clone().startOf("day")) || d.isAfter(fechas[1].clone().endOf("day"))) : undefined}
                            />
                            {v.fechas?.[0] && v.fechas?.[1] ? <span style={{ fontSize: 12, color: "#7a8794" }}>{v.fechas[1].diff(v.fechas[0], "days") + 1} días</span> : null}
                            {!bloqueado && <Button type="text" danger icon={<DeleteOutlined />} onClick={() => this.setState((s) => ({ vueltas: s.vueltas.filter((_, j) => j !== i) }))} />}
                        </div>
                    ))}
                    {!bloqueado && (
                        <ButtonItem
                            type="dashed"
                            htmlType="button"
                            icon={<PlusOutlined />}
                            onClick={() => this.setState((s) => ({ vueltas: [...s.vueltas, { _id: undefined, nombre: nombreVuelta(s.vueltas.length), fechas: [] }] }))}
                        >
                            Agregar vuelta
                        </ButtonItem>
                    )}
                    {this.state.contrato && <div className="cmms-ayuda" style={{ marginTop: 10 }}>Los cambios de vueltas se aplican al dar Guardar.</div>}
                </DynamicCardForm>
            </Row>
        );
    }

    renderFacturacion(bloqueado) {
        const c = this.state.contrato;
        const ventas = this.state.ventas;
        const setVenta = (i, cambios) => this.setState((s) => ({ ventas: s.ventas.map((v, j) => (j === i ? { ...v, ...cambios } : v)) }));
        return (
            <Row gutter={14}>
                {c && (
                    <DynamicCardForm title="Cobranza" xs={24}>
                        <Row gutter={16}>
                            <Col xs={12} md={6}>
                                <Statistic title="Valor del contrato" value={c.valorVariable ? "Variable" : formatoMoneda(c.valor) || "—"} />
                            </Col>
                            <Col xs={12} md={6}>
                                <Statistic title="Facturado" value={formatoMoneda(c.cobranza?.facturado) || "$0.00"} />
                            </Col>
                            <Col xs={12} md={6}>
                                <Statistic title="Cobrado" value={formatoMoneda(c.cobranza?.cobrado) || "$0.00"} />
                            </Col>
                            <Col xs={12} md={6}>
                                <Statistic title="Cobrado del valor" value={formatoPorcentaje(c.cobranza?.porcentajeCobrado)} />
                            </Col>
                        </Row>
                    </DynamicCardForm>
                )}
                <DynamicCardForm title="Ventas / facturas del contrato" xs={24}>
                    <div className="cmms-ayuda">Ligue las facturas o remisiones del ERP con que se cobra el contrato (las 12 facturas del C-SE-03). El cobrado se lee de cada venta. Se guarda con "Guardar".</div>
                    <Table
                        size="small"
                        rowKey={(r, i) => `${r.ventaId || "n"}-${i}`}
                        pagination={false}
                        dataSource={ventas}
                        locale={{ emptyText: "Sin ventas ligadas" }}
                        columns={[
                            {
                                title: "Venta / remisión",
                                dataIndex: "texto",
                                render: (v, r, i) =>
                                    r.ventaId && !r.editando ? (
                                        <span>
                                            {v || "Venta"} {r.cancelada ? <Tag color="red">Cancelada</Tag> : null}
                                        </span>
                                    ) : (
                                        <SelectDocumentoItem
                                            tipo="Venta"
                                            empresaId={this.props.empresaId}
                                            headersToken={this.props.headersToken}
                                            value={r.ventaId || undefined}
                                            disabled={bloqueado}
                                            onChange={(ventaId, doc) => setVenta(i, { ventaId, texto: doc?.stringBuscar || "", editando: false, total: null, pagado: null })}
                                        />
                                    ),
                            },
                            {
                                title: "Periodo",
                                dataIndex: "periodo",
                                width: 150,
                                render: (v, r, i) => (
                                    <DatePicker picker="month" format="MM/YYYY" size="small" disabled={bloqueado} value={v ? moment(v, "YYYY-MM") : null} onChange={(m) => setVenta(i, { periodo: m ? m.format("YYYY-MM") : "" })} />
                                ),
                            },
                            { title: "Total", dataIndex: "total", width: 130, align: "right", render: (v) => (v === null || v === undefined ? "—" : formatoMoneda(v)) },
                            { title: "Cobrado", dataIndex: "pagado", width: 130, align: "right", render: (v) => (v === null || v === undefined ? "—" : formatoMoneda(v)) },
                            {
                                title: "",
                                width: 50,
                                render: (_, r, i) => (!bloqueado ? <Button type="text" danger icon={<DeleteOutlined />} onClick={() => this.setState((s) => ({ ventas: s.ventas.filter((_, j) => j !== i) }))} /> : null),
                            },
                        ]}
                    />
                    {!bloqueado && (
                        <ButtonItem type="dashed" htmlType="button" icon={<PlusOutlined />} style={{ marginTop: 8 }} onClick={() => this.setState((s) => ({ ventas: [...s.ventas, { ventaId: null, texto: "", periodo: moment().format("YYYY-MM") }] }))}>
                            Ligar venta
                        </ButtonItem>
                    )}
                </DynamicCardForm>
            </Row>
        );
    }

    renderPanel(indice, contenido) {
        return <div style={{ display: this.state.paso === indice ? "block" : "none" }}>{contenido}</div>;
    }

    render() {
        const c = this.state.contrato;
        const cancelado = c?.estatus === 0;
        const bloqueado = cancelado;
        return (
            <div className="cmms-pagina">
                <PageHeader
                    title={c ? `Contrato ${c.codigo}${c.idContrato ? ` · ${c.idContrato}` : ""}` : "Nuevo contrato"}
                    subTitle={
                        c ? (
                            <span>
                                <Tag color={c.estatusColor}>{c.estatusNombre}</Tag>
                                {c.clienteNombre}
                                {c.diasRestantes !== null && c.diasRestantes >= 0 && !cancelado ? <span style={{ color: "#7a8794" }}> · {c.diasRestantes} días restantes</span> : null}
                            </span>
                        ) : (
                            ""
                        )
                    }
                    onBack={() => this.props.history.push("/panel/cmmsContratos")}
                    backIcon={<ArrowLeftOutlined />}
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10, position: "sticky", top: 0, zIndex: 5 }}
                    extra={
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                            {c && (
                                <Dropdown
                                    trigger={["click"]}
                                    overlay={
                                        <Menu
                                            onClick={({ key }) => {
                                                if (key === "renovar") this.renovar();
                                                if (key === "cancelar") this.setState({ cancelar: "" });
                                                if (key === "reactivar") this.reactivar();
                                            }}
                                        >
                                            {!cancelado && !c.renovadoEn && (
                                                <Menu.Item key="renovar" icon={<SyncOutlined />}>
                                                    Renovar contrato
                                                </Menu.Item>
                                            )}
                                            {!cancelado ? (
                                                <Menu.Item key="cancelar" danger icon={<StopOutlined />}>
                                                    Cancelar contrato
                                                </Menu.Item>
                                            ) : (
                                                <Menu.Item key="reactivar" icon={<UndoOutlined />}>
                                                    Reactivar contrato
                                                </Menu.Item>
                                            )}
                                        </Menu>
                                    }
                                >
                                    <Button icon={<MoreOutlined />} />
                                </Dropdown>
                            )}
                            {!cancelado && (
                                <ButtonItem type="primary" icon={<SaveOutlined />} onClick={() => this.formRef.current?.submit()}>
                                    Guardar
                                </ButtonItem>
                            )}
                        </div>
                    }
                />
                {cancelado && <Alert type="error" showIcon style={{ marginBottom: 10 }} message={`Contrato cancelado: ${c.motivoCancelacion || ""}`} />}
                {c?.renovadoEn && (
                    <Alert
                        type="info"
                        showIcon
                        style={{ marginBottom: 10 }}
                        message={
                            <span>
                                Este contrato se renovó en{" "}
                                <Button type="link" style={{ padding: 0, height: "auto" }} onClick={() => this.props.history.push("/panel/cmmsContrato", { id: c.renovadoEn._id })}>
                                    {c.renovadoEn.nombre}
                                </Button>
                                . Sus equipos ahora están en el nuevo.
                            </span>
                        }
                    />
                )}
                {c?.renovadoDe && (
                    <div className="cmms-ayuda" style={{ margin: "0 0 10px 0" }}>
                        Renovación de{" "}
                        <Button type="link" size="small" style={{ padding: 0, height: "auto" }} onClick={() => this.props.history.push("/panel/cmmsContrato", { id: c.renovadoDe._id })}>
                            {c.renovadoDe.nombre}
                        </Button>
                    </div>
                )}
                <Spin spinning={this.state.loading}>
                    {this.renderPasos()}
                    <FormAntd
                        ref={this.formRef}
                        name="contratoCMMS"
                        layout="vertical"
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && e.target.type !== "textarea") e.preventDefault();
                        }}
                    >
                        {this.renderPanel(0, this.renderGeneral(bloqueado))}
                        {this.renderPanel(1, this.renderVueltas(bloqueado))}
                        {this.renderPanel(5, this.renderFacturacion(bloqueado))}
                    </FormAntd>
                    {c && this.state.paso === 2 && (
                        <EquiposContrato {...this.props} contrato={c} recarga={this.state.recarga} bloqueado={bloqueado} onCambio={() => this.consultar()} />
                    )}
                    {c && this.state.paso === 3 && <CalendarizacionContrato {...this.props} contrato={c} recarga={this.state.recarga} bloqueado={bloqueado} motivos={this.state.motivos} />}
                    {c && this.state.paso === 4 && <ProgresoContrato {...this.props} contrato={c} recarga={this.state.recarga} />}
                    {this.renderNavegacion()}
                </Spin>
                <Modal
                    visible={this.state.cancelar !== null}
                    title="Cancelar contrato"
                    onCancel={() => this.setState({ cancelar: null })}
                    onOk={this.cancelarContrato}
                    okText="Cancelar contrato"
                    cancelText="Regresar"
                    okButtonProps={{ danger: true }}
                >
                    <Alert type="warning" showIcon style={{ marginBottom: 10 }} message="Lo pendiente del programa queda como 'No realizado: Contrato cancelado'. Los servicios ya hechos se conservan. Se puede reactivar después." />
                    <Input.TextArea rows={3} placeholder="Motivo de la cancelación (obligatorio)" value={this.state.cancelar || ""} onChange={(e) => this.setState({ cancelar: e.target.value })} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Contrato);
